import React from 'react';
import Consensus from './Consensus';
import { api_bd_nr } from '../../services/Api';
import { CheckCheck, Trash2 } from 'lucide-react'

const BonusesListComponent = ({ data, openModal2, closeModal2, loggedUser, refreshData, d, selectedMonth, selectedYear, setData, setBtnDisabled }) => {
    return (
        <details
            className='w-full pb-4 border-b-[1px] border-b-gray-400 details-wrapper'
            style={{ justifySelf: 'flex-start' }}
        >
            <summary className='text-[1.2em]'>{data?.bonuses?.length > 0 ? <><b>Lista de bonificações  ({String(data?.bonuses?.length).padStart(2, '0')})</b></> : <b>Nenhuma bonificação registrada para este usuário</b>}</summary>
            <div className='space-y-6 w-full' style={{ overflowY: 'auto', position: 'relative' }}>
                {data?.bonuses?.map((el, index) => (
                    <div key={`summary_${index}`} className='flex space-x-4 flex-row w-full h-full  bg-slate-100 rounded'>
                        <div className='h-full w-full'>
                            <p className='mt-2 flex flex-col'>
                                <span style={{ textWrap: 'wrap' }}>Bonificação: <b>{el?.name}</b></span>
                                <span style={{ textWrap: 'wrap' }}>Pontuação: <b>{el?.point}</b></span>
                                <span style={{ textWrap: 'wrap' }}>Data: <b>{el?.date ? new Date(el?.date)?.toLocaleDateString() : new Date()?.toLocaleDateString()}</b></span>
                                <span style={{ textWrap: 'wrap' }}>Observação: <b>{el?.valuerNote}</b></span>
                                {/* {el?.consensus?.active &&
                                    <span style={{ textWrap: 'wrap' }}>Consenso: <b>{el?.consensus?.obs}</b></span>
                                }*/}

                                {loggedUser.nivel.match(/Super|Técnico-Admin/) &&
                                    <span style={{ textWrap: 'wrap' }}>Avaliador: <b>{el?.valuer?.name}</b></span>
                                } 
                            </p>
                        </div>

                        {(el?._id && (loggedUser.nivel.match(/Super|Técnico-Admin/))) &&
                            <div className='flex flex-grow flex-col pr-4 space-y-1 justify-around items-center min-w-[80px] max-w-[80px] h-auto'>
                                {/* <button
                                    className={`flex justify-center w-[80px] px-4 py-1 ${el?.consensus?.active ? ' bg-green-700' : ' bg-blue-900'} text-white rounded font-bold cursor-pointer`}
                                    onClick={() => {
                                        if (openModal2) {
                                            openModal2(<Consensus
                                                data={el}
                                                loggedUser={loggedUser}
                                                onSave={(val) => {
                                                    const { active, obs, point, valuer } = val

                                                    // const dataWithConsensus = {
                                                    //     ...data,
                                                    //     bonuses: data.bonuses.map(infraction => {
                                                    //         if (infraction._id === el._id) {
                                                    //             return ({
                                                    //                 ...infraction,
                                                    //                 point,
                                                    //                 consensus: { active, obs, valuer }
                                                    //             })
                                                    //         }
                                                    //     })
                                                    // }
                                                    // console.log('dataWithConsensus', dataWithConsensus)

                                                    const month = selectedMonth || String(d.getMonth() + 1).padStart(2, '0')
                                                    const year = d.getFullYear()
                                                    api_bd_nr.put(`/performance-radar/consensus?id=${el._id}`, {
                                                        month,
                                                        year,
                                                        point,
                                                        consensus: { active, obs, valuer },
                                                    })
                                                        .then(({ data }) => {
                                                            setData(current => {
                                                                return ({
                                                                    ...current,
                                                                    bonuses: current.bonuses.map(infraction => {
                                                                        if (infraction._id === el._id) {
                                                                            return ({
                                                                                ...infraction,
                                                                                point,
                                                                                consensus: { active, obs, valuer }
                                                                            })
                                                                        } else {
                                                                            return infraction
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                            if (refreshData) {
                                                                refreshData()
                                                            }
                                                            // alert("Erro ao adicionar o consenso, tente novamente, se o erro persistir contate o suporte")
                                                        })
                                                        .catch((e) => {
                                                            alert("Erro ao adicionar o consenso, tente novamente, se o erro persistir contate o suporte")
                                                            console.log('update consensus error: ', e)
                                                        })
                                                    if (closeModal2) {
                                                        closeModal2()
                                                    }
                                                }}
                                            />)
                                        }
                                    }}
                                >
                                    <CheckCheck />
                                </button> */}
                                <button
                                    className='flex justify-center  w-[80px] px-4 py-1  bg-blue-900 text-white rounded font-bold cursor-pointer'
                                    onClick={() => {
                                        if (window.confirm('Deseja remover esta bonificação?')) {
                                            api_bd_nr.delete(`/performance-radar/points?type=b&id=${el._id}`)
                                                .then((resp) => {
                                                    const temp = {
                                                        ...data,
                                                        bonuses: data?.bonuses.filter(ell => ell._id !== el._id)
                                                    }
                                                    setData(temp)

                                                    alert('Ação realizada com sucesso!')
                                                    if (refreshData) {
                                                        refreshData()
                                                    }
                                                })
                                                .catch(e => {
                                                    setBtnDisabled(false)
                                                    console.log('delete error: ', e)
                                                })
                                        }
                                    }}
                                >
                                    <Trash2 />
                                </button>
                            </div>
                        }
                    </div>
                ))}
            </div>
        </details>
    );
};

export default BonusesListComponent;
